export const environment = {
    production: 'https://mu-meet-api.mastersunion.org'
,
    development: 'http://localhost:5002'

  }